import AlertBox from '@/components/AlertBox';
import React, { createContext, useState, useEffect } from 'react';

export const NavigationBlockerContext = createContext<{
  isDirty: boolean;
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>;
}>({
  isDirty: false,
  setIsDirty: () => {
    // set whether the form state is dirty
  },
});

export const NavigationBlockerProvider = ({ children }: { children: React.ReactNode }) => {
  const [isDirty, setIsDirty] = useState(false);
  const [showAlert, setShowAlert] = useState<boolean>(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.ctrlKey || event.metaKey) && event.key === 'r') {
        if (isDirty) {
          event.preventDefault();
          setShowAlert(true);
        }
      } else if (event.key === 'F5') {
        if (isDirty) {
          event.preventDefault();
          setShowAlert(true);
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isDirty]);

  const handleConfirmNavigation = () => {
    window.location.reload();
  };

  const handleCancelNavigation = () => {
    setShowAlert(false);
  };

  return (
    <>
      <NavigationBlockerContext.Provider value={{ isDirty, setIsDirty }}>{children}</NavigationBlockerContext.Provider>
      {showAlert && (
        <AlertBox
          open={true}
          description="Changes which you made might not be saved."
          title="Are you sure?"
          confirmBtnClick={handleConfirmNavigation}
          cancelBtnClick={handleCancelNavigation}
          confirmBtnLabel="Yes"
          cancelBtnLabel="No"
          warning
        />
      )}
    </>
  );
};
